import { render, staticRenderFns } from "./configEdit.vue?vue&type=template&id=0ce6cc22&scoped=true"
import script from "./configEdit.vue?vue&type=script&lang=js"
export * from "./configEdit.vue?vue&type=script&lang=js"
import style0 from "./configEdit.vue?vue&type=style&index=0&id=0ce6cc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6cc22",
  null
  
)

export default component.exports